import React from 'react';
import SearchBarComponent from './SearchBar.component';

/**
 * SearchBar 에디터 컴포넌트
 * 에디터에서 사용하는 SearchBar 래퍼
 */
const SearchBarEditor: React.FC<any> = (props) => {
  return <SearchBarComponent {...props} />;
};

export default SearchBarEditor;